import * as React from 'react';
import classnames from 'classnames';
import { ScreenUtils, Spinner } from './controls';
import BaseComponent from './BaseComponent';

export class WaitingOverlay extends BaseComponent<{ minimalHeader: boolean }, { show: boolean, isTopView: boolean }> {

	private ref = React.createRef<HTMLDivElement>();

	createInitialState(_props: { minimalHeader: boolean }): Nullable<{ show: boolean; isTopView: boolean }> {
		return { show: false, isTopView: true };
	}

	onComponentDidMount(): void {
		const updateIsTopView = async () => {
			if (this.mounted)
				this.setState({ isTopView: ScreenUtils.isInTopView(this.ref.current!) });
		};

		this.on('pos-screen:opened', updateIsTopView);
		this.on('pos-screen:closed', updateIsTopView);
		this.on('dialog:opened', updateIsTopView);
		this.on('dialog:closed', updateIsTopView);
	}

	resolvePendingPromises: Array<() => void> = [];

	onComponentWillUnmount(): void {
		this.resolvePendingPromises.forEach(resolve => resolve());
	}

	// Hago show awaitable para que se pueda esperar a que se esté mostrando el overlay antes de seguir
	show(): Promise<void> {
		return new Promise(resolve => {
			// Guardo una referencia al resolve para resolver la promesa si me desmontan antes de que se ejecute
			// la callback de setState, y no puedo resolverla de la forma normal. Necesito mantener un array de
			// resolves porque se podrían haber ejecutado varios shows a la vez si desde PosScreen se han lanzado
			// varios requests dentro del flujo de un único execute.
			this.resolvePendingPromises.push(resolve);
			this.setState({ show: true }, () => {
				this.resolvePendingPromises.remove(resolve);
				resolve();
			});
		});
	}

	hide() {
		// Dejo un pequeño margen para se puedan repintar componentes como
		// los planos de mesas, que necesitan algo de tiempo para actualizar
		// su DOM tras el primer render
		setTimeout(() => this.setState({ show: false }), 50);
	}

	render() {
		const classNames = classnames({
			'waiting-overlay': true,
			'header-minimal': this.props.minimalHeader,
			'waiting-overlay-top-view': this.state.isTopView
		});

		return this.state.show
			? <div ref={this.ref} tabIndex={0} className={classNames}><Spinner /></div>
			: <div ref={this.ref} />;
	}
}
